import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { SsoApiService } from '~shared/services/api/general/sso.api-service';
import { ssoErrorCode } from '~shared/services/sso/sso-error.util';
import {
  SSO_FALLBACK_ERROR_CODE,
  SsoErrorCode,
} from '~shared/models/general/sso.model';
import { SharedActions } from '~shared/store/shared.actions';

/** Paramètres renvoyés par le fournisseur sur l'URL de retour. */
const CODE_PARAM = 'code';
const STATE_PARAM = 'state';
const PROVIDER_ERROR_PARAM = 'error';

/** Retour du fournisseur sans code (annulation, refus) : ce n'est pas un refus de la plateforme. */
const PROVIDER_REFUSAL_CODE: SsoErrorCode = 'SSO_PROVIDER_REFUSED';

/**
 * Route publique de retour du fournisseur d'identité : échange le code contre
 * le jeton de la plateforme, retire code et état de l'historique, puis ouvre
 * la session comme une connexion par mot de passe.
 */
@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  imports: [TranslateModule, RouterLink],
})
export class AuthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);
  private ssoApi = inject(SsoApiService);

  readonly errorCode = signal<SsoErrorCode | null>(null);

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const code = params.get(CODE_PARAM);
    const state = params.get(STATE_PARAM);
    // Le code n'est utilisable qu'une fois : on le retire tout de suite de l'URL.
    this.router.navigate([], { replaceUrl: true, queryParams: {} });

    if (params.get(PROVIDER_ERROR_PARAM)) {
      this.errorCode.set(PROVIDER_REFUSAL_CODE);
      return;
    }
    if (!code || !state) {
      this.errorCode.set(SSO_FALLBACK_ERROR_CODE);
      return;
    }

    this.ssoApi.callback(code, state).subscribe({
      next: ({ token }) => {
        // L'effet loginSuccess enregistre le jeton (synchrone) puis charge /me.
        this.store.dispatch(
          SharedActions.loginSuccess({ token, remember: false })
        );
        this.router.navigate(['/'], { replaceUrl: true });
      },
      error: (error: unknown) => this.errorCode.set(ssoErrorCode(error)),
    });
  }
}
